<template>
  <div class="basic-group-info mt-4">
    <b-row>
      <b-col>
        <h4 class="subtitle">Group Type</h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="dropdown mt-4">
            <b-form-select v-model="groupType">
              <option
              v-for="(type,index) in types"
              :key="index"
              :value="type"
              >{{ type }}</option>
            </b-form-select>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'GroupType',
  data() {
    return {
    }
  },
  computed: {
    types: {
      get() {
        console.log(this.$store.state.groupTypes);
        return this.$store.state.groupTypes;
      },
    },
    groupType: {
      get() {
        return this.$store.state.groups.group.type;       
      },
      set(val) {
        console.log('Saving: ',val);
        this.$store.commit(`groups/type`, val);
      }
    },
    typeInput() {
      return this.$store.state.groups.group.type.length > 2;
    },
  },
};
</script>

<style scoped>
.bold {
  font-weight: bold;
}
</style>
